import { clsx } from "clsx";
import type { ReactNode } from "react";

const paddingClasses = {
  none: "",
  sm: "p-4",
  md: "p-5",
  lg: "p-8",
} as const;

export interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: keyof typeof paddingClasses;
}

export function Card({ children, className, padding = "md" }: CardProps) {
  return (
    <div
      className={clsx(
        "rounded-lg border border-edge bg-panel",
        paddingClasses[padding],
        className,
      )}
    >
      {children}
    </div>
  );
}
